import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Academic from "./academic";

function Academics(){
    return(
       
    <div className="Academics" style={{backgroundColor: "black"}}>
       <Navbar/>
<Academic/>
<Footer/>

        </div>

    )
}
export default Academics;